<template>
  <div>

    <el-row  class="padded" justify="center">
      <el-col :span="24">
        <h3><i class="fa fa-cog">&nbsp;</i><org-badge />&nbsp;Settings</h3>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="2">

        <el-menu :default-active="menu" :collapse="true" @select="onSelect" background-color="#F2F6FC">

          <el-menu-item-group title="Organisations">
            <template #title>
              <el-tooltip content="Organisations" effect="light" placement="right">
                <i class="fa fa-th-large text-muted"></i>
              </el-tooltip>
            </template>

            <el-menu-item index="orgs-towerco" v-if="isManager()">
              <i class="fa fa-star">&nbsp;</i>
              <template #title><span>{{ellipsis(clientName, 15)}}</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-telco" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-users">&nbsp;</i>
              <template #title><span>Telcos</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-contractor" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-tools">&nbsp;</i>
              <template #title><span>Contractors</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-backhaul" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-wifi">&nbsp;</i>
              <template #title><span>Backhaul Providers</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-landlord" v-if="canAccess('property|finance|management')">
              <i class="fa fa-home">&nbsp;</i>
              <template #title><span>Landlords</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-insurer" v-if="canAccess('admin|property|finance|management')">
              <i class="fa fa-shield-alt">&nbsp;</i>
              <template #title><span>Insurers</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-utility" v-if="canAccess('admin|property|finance|management')">
              <i class="fa fa-plug">&nbsp;</i>
              <template #title><span>Utilities</span></template>
            </el-menu-item>

            <el-menu-item index="orgs-authority" v-if="canAccess('admin|property|finance|management')">
              <i class="fa fa-university">&nbsp;</i>
              <template #title><span>Authorities</span></template>
            </el-menu-item>


            <el-menu-item index="orgs-tower-supplier" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-tower-cell">&nbsp;</i>
              <template #title><span>Tower Suppliers</span></template>
            </el-menu-item>

          </el-menu-item-group>


          <el-menu-item-group v-if="isManager()">
            <template #title>
              <el-tooltip content="System" effect="light" placement="right">
                <i class="fa fa-tasks text-muted"></i>
              </el-tooltip>
            </template>

            <el-menu-item index="workflow" v-if="isManager('project|maintenance|admin')">
              <i class="fa fa-cogs">&nbsp;</i>
              <template #title><span>Master Workflows</span></template>
            </el-menu-item>

            <el-menu-item index="cats" v-if="isSuper()">
              <i class="fa fa-tags">&nbsp;</i>
              <template #title><span>Categories</span></template>
            </el-menu-item>

            <el-menu-item index="loc">
              <i class="fa fa-map-pin">&nbsp;</i>
              <template #title><span>Localities</span></template>
            </el-menu-item>

            <el-menu-item index="struct">
              <i class="fa fa-broadcast-tower">&nbsp;</i>
              <template #title><span>Structures</span></template>
            </el-menu-item>
<!--
            <el-menu-item index="users">
              <i class="fa fa-user">&nbsp;</i>
              <template #title><span>Users</span></template>
            </el-menu-item>
-->
          </el-menu-item-group>

          <el-menu-item-group v-if="isManager()">
            <template #title>
              <el-tooltip content="Other Settings" effect="light" placement="right">
              <i class="fa fa-random text-muted">&nbsp;</i>
            </el-tooltip>
            </template>

            <el-menu-item index="finance" v-if="isManager('finance|management|admin')">
              <i class="fa fa-dollar-sign">&nbsp;</i>
              <template #title><span>Finance</span></template>
            </el-menu-item>

            <el-menu-item index="backup" v-if="isManager()">
              <i class="fa fa-save">&nbsp;</i>
              <template #title><span>Backup Data</span></template>
            </el-menu-item>

            <el-menu-item index="logs" v-if="isManager()">
              <i class="fa fa-user">&nbsp;</i>
              <template #title><span>System Users</span></template>
            </el-menu-item>

          </el-menu-item-group>
        </el-menu>
      </el-col>

      <el-col :span="21">

        <div>
          <component v-bind="defaultProps" :is="comp" />
        </div>

      </el-col>
    </el-row>
  </div>

</template>

<script>

import FormattingMixins from '@/mixins/FormattingMixins'

import ComingSoon from '@/components/settings/ComingSoon'

import AuditLogs from '@/components/settings/AuditLogs'

import Backup from '@/components/settings/Backup'
import Categories from '@/components/settings/Categories'

import FinanceSettings from '@/components/settings/FinanceSettings'
import Locality from '@/components/settings/Locality'

import StructTable from '@/components/tables/StructTable'
import OrgTable from '@/components/tables/OrgTable'

import Workflow from '@/components/workflow/Workflow'
import { SETTINGS_SLUG_TO_CATEGORY } from '@/lib/settingsSlugs'

export default {
  mixins: [FormattingMixins],

  computed: {
    clientName () { return this.xolasClient().name },
    clientLogo () { return this.xolasClient().logoPath }
  },

  methods: {
    onSelect (index) {
      // NavigationDuplicated guard — avoid pushing the same route
      if (this.$route.params.settingTab === index) return
      this.$router.push({ params: { settingTab: index, financeTab: undefined, drawerPath: undefined }, query: this.$route.query })
    },

    show (menu) {

      this.comp = ComingSoon

      delete this.defaultProps.category
      delete this.defaultProps.title
      delete this.defaultProps.showSearch

      if (menu.startsWith('orgs')) {
        // XOL-392: `orgs-xolas` was renamed to `orgs-towerco` (every sibling
        // slug names an org CATEGORY; that one named the vendor). The rename is
        // a URL/label change ONLY — the category handed to OrgTable becomes
        // `/org?filter=<category>`, and the underlying org category is still
        // the Xolas client one, so the filter value must not follow the slug or
        // the table comes back empty. SETTINGS_SLUG_TO_CATEGORY holds the one
        // slug whose category is not simply itself.
        this.defaultProps.category = Object.prototype.hasOwnProperty.call(SETTINGS_SLUG_TO_CATEGORY, menu)
          ? SETTINGS_SLUG_TO_CATEGORY[menu]
          : menu.replace('orgs-', '').replace('-', ' ')

        this.defaultProps.title = this.pluralise(this.titleCase(this.defaultProps.category === 'backhaul' ? 'Backhaul Providers' : this.defaultProps.category))

        var isClientOrgTab = this.defaultProps.category === 'xolas'

        this.defaultProps.showSearch = !isClientOrgTab
        this.defaultProps.showRefresh = !isClientOrgTab

        if (isClientOrgTab) {
          this.defaultProps.title = this.xolasClient().name
        }

//        console.log('Settings: ', this.defaultProps)
        this.comp = OrgTable
      }

      if (menu === 'cats') {
        this.comp = Categories
      }

      if (menu === 'finance') {
        this.comp = FinanceSettings
      }

      if (menu === 'loc') {
        this.comp = Locality
      }

      if (menu === 'struct') {
        this.comp = StructTable
      }

      if (menu === 'workflow') {
        this.comp = Workflow
      }

      if (menu === 'backup') {
        this.comp = Backup
      }

      if (menu === 'logs') {
        this.comp = AuditLogs
      }

    }
  },

  watch: {
    '$route': {
      handler: function (route) {
        var tab = route.params.settingTab
        if (!tab) return  // bare /settings → keep default (OrgTable, no highlight) — decision 1
        this.menu = tab
        this.show(tab)    // existing switch sets this.comp + defaultProps
      },
      immediate: true
    }
  },

  data () {
    return {
      menu: '',  // no menu item highlighted on bare /settings — decision 1
      comp: OrgTable,
      telcoId: this.isTelco() ? this.org().id : null,
      defaultProps: {}
    }

  }
}

</script>

<style scoped>
.menu-header { color: darkorange; }
</style>
